<template>
    <div>
        <dynamic-form :formConfig="formConfig" v-model="form" @submit="submit"></dynamic-form>
    </div>
</template>
<script>
import '@/components/dynamic-form';
export default {
    data() {
        return {
            form: {},
            formConfig: {
                inline: true,
                labelPosition: "right",
                labelWidth: "",
                size: "small",
                statusIcon: true,
                formItemList: [
                    {
                        span: 12,
                        key: "date",
                        value: null,
                        disabled: false,
                        rules: [
                            {
                            required: "true",
                            message: "此项为必填项"
                            }
                        ],
                        placeholder: "请选择",
                        type: "date",
                        subtype: "date",
                        label: "日期",
                        valueFormat: "yyyy-MM-dd"
                    },
                    {
                        span: 12,
                        key: "dateTime0",
                        value: null,
                        disabled: false,
                        placeholder: "请选择",
                        type: "date",
                        subtype: "datetime",
                        label: "日期时间",
                        valueFormat: "yyyy-MM-dd"
                    },
                    {
                        span: 12,
                        key: "dateTime",
                        value: null,
                        disabled: false,
                        placeholder: "请选择",
                        type: "date",
                        subtype: "datetime",
                        label: "日期时间2",
                        valueFormat: "yyyy-MM-dd HH:mm"
                    },
                    {
                        span: 12,
                        key: "time",
                        value: null,
                        disabled: false,
                        placeholder: "请选择",
                        type: "time",
                        subtype: "time",
                        label: "时间",
                    },
                    {
                        span: 12,
                        key: "year",
                        value: null,
                        disabled: false,
                        placeholder: "请选择",
                        type: "date",
                        subtype: "year",
                        label: "年",
                    },
                    {
                        span: 12,
                        key: "month",
                        value: null,
                        disabled: false,
                        placeholder: "请选择",
                        type: "date",
                        subtype: "month",
                        label: "月"
                    },
                    {
                        span: 12,
                        key: "dateRange",
                        value: null,
                        disabled: false,
                        placeholder: "请选择",
                        type: "date",
                        subtype: "daterange",
                        label: "日期范围",
                    },
                    { // TODO 好像有问题
                        span: 12,
                        key: "timeRange",
                        disabled: false,
                        type: "time",
                        subtype: "timerange",
                        label: "时间范围",
                        startPlaceholder: '开始时间',
                        endPlaceholder: '结束时间'
                    },
                    {
                        span: 12,
                        type: "date",
                        value: [
                            "2019-07-03 12:00:00 am",
                            "2019-07-11 12:00:00 am"
                        ],
                        disabled: false,
                        placeholder: "请选择",
                        key: "dateTimeRange",
                        subtype: "datetimerange",
                        label: "时间日期范围",
                        valueFormat: "yyyy-MM-dd hh:mm:ss"
                    }
                ]
            },
        }
    },
    methods: {
        submit(v) {
            console.log(v)
        }
    }
}
</script>
